// ==========================================
// Skill Definitions
// ==========================================

export type SkillLevel = 0 | 1 | 2 | 3; // 0 = nicht vorhanden, 1-3 = Abstufungen

export interface SkillDefinition {
  id: string;
  emoji: string;
  name: string;
  description: string;
}

export const SKILL_DEFINITIONS: SkillDefinition[] = [];

// Automatisch generiertes Emoji zu Skill-ID Mapping
export const EMOJI_TO_SKILL: Record<string, string> = Object.fromEntries(
  SKILL_DEFINITIONS.map(skill => [skill.emoji, skill.id])
);

// Skill-ID zu Emoji Mapping (Reverse)
export const SKILL_TO_EMOJI: Record<string, string> = Object.fromEntries(
  SKILL_DEFINITIONS.map(skill => [skill.id, skill.emoji])
);

// Helper: Skill-Definition nach ID finden
export function getSkillById(skillId: string): SkillDefinition | undefined {
  return SKILL_DEFINITIONS.find(s => s.id === skillId);
}

// Helper: Skill-Definition nach Emoji finden
export function getSkillByEmoji(emoji: string): SkillDefinition | undefined {
  const skillId = EMOJI_TO_SKILL[emoji];
  return skillId ? getSkillById(skillId) : undefined;
}

// Skill Level Labels
export const SKILL_LEVEL_LABELS: Record<SkillLevel, string> = {
  0: "-",
  1: "Basis",
  2: "Fortgeschritten",
  3: "Experte",
};

// Skill Level Farben (Tailwind Classes)
export const SKILL_LEVEL_COLORS: Record<SkillLevel, string> = {
  0: "bg-gray-100 text-gray-400",
  1: "bg-amber-100 text-amber-700 border-amber-300",
  2: "bg-blue-100 text-blue-700 border-blue-300",
  3: "bg-emerald-100 text-emerald-700 border-emerald-300",
};
